"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = convertToKebabCase;
function convertToKebabCase(camelCasedText) {
  return camelCasedText.replace(/[A-Z]/g, function (letter) {
    return "-".concat(letter.toLowerCase());
  });
}